import { createFileRoute } from "@tanstack/react-router";
import { BudgetDetail } from "../../features/billing/budget-detail";
import { BillingLayout } from "../../features/billing/layout";

export const Route = createFileRoute("/_authed/$org/billing/budgets/$name")({
  component: BudgetPage,
});

function BudgetPage() {
  const { org, name } = Route.useParams();
  return (
    <BillingLayout
      org={org}
      tab="budgets"
      cli={`nodus get budget ${name} -o yaml`}
    >
      <BudgetDetail org={org} name={name} />
    </BillingLayout>
  );
}
